import clsx from 'clsx'

type MessagesSkeletonProps = {
  numberOfMessages?: number
  className?: string
}
export const MessagesSkeleton = ({numberOfMessages = 3, className = ''}: MessagesSkeletonProps) => {
  return (
    <div className={clsx('d-flex flex-column gap-3 mb-2 mx-4', className)}>
      {new Array(numberOfMessages).fill('').map((_, index) => (
        <span
          key={index}
          className={clsx('h-45px w-75 placeholder placeholder-lg rounded-3 bg-secondary', {
            'align-self-end': index % 2 === 0,
            'align-self-start': index % 2 !== 0,
          })}
        />
      ))}
    </div>
  )
}
